import { render } from "./SendForm.vue?vue&type=template&id=bf33405a&scoped=true"
import script from "./SendForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SendForm.vue?vue&type=script&setup=true&lang=js"

import "./SendForm.vue?vue&type=style&index=0&id=bf33405a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf33405a"],['__file',"src/views/sms/send/SendForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf33405a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf33405a', __exports__)) {
    console.log('reload')
    api.reload('bf33405a', __exports__)
  }
  
  module.hot.accept("./SendForm.vue?vue&type=template&id=bf33405a&scoped=true", () => {
    console.log('re-render')
    api.rerender('bf33405a', render)
  })

}


export default __exports__